export default "__VITE_ASSET__210c02f1__"